import React from 'react';
import {useTranslation} from 'react-i18next';

import range from 'lodash/range';

import {SkeletonItem} from '@edna/components/primitives';

import {DiverImage, EmptyImage} from 'src/images';

import PageDialog from '../PageDialog';
import ScrollUpButton from '../ScrollUpButton';
import {EListState, PAGE_SIZE, TListState} from './definitions';
import * as S from './style';

const ListError = React.memo(() => {
  const {t} = useTranslation();

  return (
    <PageDialog
      title={t('List:errorLoadingList.title')}
      subtitle={t('List:errorLoadingList.subtitle')}
      text={t('List:errorLoadingList.hint')}
      imageComponent={EmptyImage}
    />
  );
});

const ListNoData = React.memo(() => {
  const {t} = useTranslation();

  return <PageDialog title={t('List:noData')} imageComponent={DiverImage} />;
});

const ListPending = React.memo<{size?: number}>(({size = PAGE_SIZE}) => (
  <S.SkeletonList>
    {range(size).map((index) => (
      <SkeletonItem key={index} height="40px" />
    ))}
  </S.SkeletonList>
));

const ListNotFound = React.memo(() => {
  const {t} = useTranslation();

  return (
    <PageDialog
      title={t('List:nothingFound')}
      subtitle={t('List:nothingFoundSubtitle')}
      imageComponent={EmptyImage}
    />
  );
});

type TListActionsProps = {
  state: TListState;
  className?: string;
  children: React.ReactNode;
};

const ListActions = React.memo<TListActionsProps>(({state, children, className}) => (
  <S.ListActions className={className} disabled={state === EListState.PENDING}>
    {children}
  </S.ListActions>
));

type TListTotal = {
  count?: number;
  title?: string;
};

const ListTotal = React.memo<TListTotal>(({count, title}) => {
  const {t} = useTranslation();

  if (count && title) {
    return (
      <S.ListTotal>
        {t('List:totalElements', {
          count,
          title,
        })}
      </S.ListTotal>
    );
  }

  return null;
});

export {ListTotal, ScrollUpButton, ListError, ListNoData, ListNotFound, ListPending, ListActions};
export const {ListActionsMain, ListActionsItem, TableHead} = S;
